"use client"

import { AboutUsSectionProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { AboutUsSectionContent } from "./components/AboutUsSectionContent"

export const RenderConfig: ComponentConfig<AboutUsSectionProps> = {
  render: ({ title, description, floorPlanImage, logo, mainImage, styles, responsiveType, className }) => {
    const id = `about-us-section-${Math.random().toString(36).substr(2, 9)}`
    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <div
          id={id}
          className={twMerge(
            "container mx-auto max-w-[1200px] pt-[1rem] pb-0 sm:pt-[6.25rem] sm:pb-[2rem]",
            id,
            className,
          )}
        >
          <AboutUsSectionContent
            title={title}
            description={description}
            floorPlanImage={floorPlanImage}
            logo={logo}
            mainImage={mainImage}
          />
        </div>
      </>
    )
  },
}
